import React, { useState } from 'react'
import { DataGrid } from '@mui/x-data-grid';
import { Stack } from '@mui/material/';
import { InputFile } from '../../components/conflict-mineral/InputFile';
import { Template } from '../../components/conflict-mineral/Template'
import { Form, Button, Col } from '@deere/ux.uxframe-react'
import { validateSupplierNumbersByChunk } from '../../services/external.service';
import { createCOOAssignments, validateSupplierPart, validateDuplicates } from '../../utils/fileUtil'
import { SUPPLIER_NUMBER_COO_COLUMN, PART_COO_COLUMN, DESCRIPTION_COO_COLUMN, TEMPLATE_COO_COLUMNS, TEMPLATE_NAME, UNIT_CODE_COO_COLUMN } from '../../utils/surveyLiterals'
import { ERR_SUPPLIER_REQUIRED, ERR_COLUMNS_REQUIRED, ERR_RECORDS_REQUIRED, ERR_ROW_DUPLICATED, ERR_REMOVE_EMPTY_LINES, ERR_SUP_NUM_INVALID, ERR_ALL_SUP_INVALID } from "../../utils/errorLiterals";

export const CooCard = ({ loading, setLoading, setErrorMessage, setSuccessMessage, campaign, setValidated, setDisableSubmit, authState, userInfo }) => {
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);

    const validateSupplierNumbers = () => {
        setLoading(true);
        setSuccessMessage('');
        setErrorMessage('');

        if (!Array.isArray(data) || data.length <= 0) {
            setValidated(true);
            setDisableSubmit(true);
            setErrorMessage(ERR_SUPPLIER_REQUIRED);
            setLoading(false);
            return;
        }
        const colSupplier = columns.find(col => col.headerName === SUPPLIER_NUMBER_COO_COLUMN)
        const colPart = columns.find(col => col.headerName === PART_COO_COLUMN)
        const colDescription = columns.find(col => col.headerName === DESCRIPTION_COO_COLUMN)
        if (!Array.isArray(columns) || !colSupplier || !colPart || !colDescription) {
            setValidated(true);
            setDisableSubmit(true);
            setErrorMessage(`${ERR_COLUMNS_REQUIRED} ${SUPPLIER_NUMBER_COO_COLUMN}, ${PART_COO_COLUMN} and ${DESCRIPTION_COO_COLUMN}.`);
            setLoading(false);
            return;
        }
        const duplicates = validateDuplicates(data,SUPPLIER_NUMBER_COO_COLUMN,PART_COO_COLUMN, UNIT_CODE_COO_COLUMN)
        const colsToValidate = [SUPPLIER_NUMBER_COO_COLUMN,PART_COO_COLUMN,DESCRIPTION_COO_COLUMN];
        const validSupplierPart = validateSupplierPart(data,colsToValidate);
        if (validSupplierPart.length > 0) {
            setValidated(true);
            setDisableSubmit(true);
            setErrorMessage(`${ERR_RECORDS_REQUIRED} : ${validSupplierPart.map(element => element)}`);
            setLoading(false);
            return;
        }
        if (duplicates.length > 0) {
            setValidated(true);
            setDisableSubmit(true);
            setErrorMessage(`${ERR_ROW_DUPLICATED} : ${duplicates.map(element => element)}`);
            setLoading(false);
            return;
        }
        const suppliers = data.map(element => element[SUPPLIER_NUMBER_COO_COLUMN]);
        if (Array.isArray(suppliers) && suppliers.length > 0) {
            const uniqueSuppliers = Array.from(new Set(suppliers));
            const formattedSuppliers = uniqueSuppliers.map(s => { return s !== null && s !== undefined ? s.toString().trim().padStart(10, '0') : "" })
            validateSupplierNumbersByChunk(authState.accessToken.accessToken, formattedSuppliers).then(sup => {
                if (sup && sup.length > 0) {
                    setValidated(true);
                    setDisableSubmit(true);
                    let errMsg = sup[0].length > 0 ? sup[0].join(', ') : sup[0]
                    if (errMsg === ', ' || errMsg.length === 0) {
                        setErrorMessage(ERR_REMOVE_EMPTY_LINES)
                    } else {
                        setErrorMessage(`${ERR_SUP_NUM_INVALID}: ${errMsg}`)
                    }
                } else {
                    setValidated(false);
                    setDisableSubmit(false);
                    campaign.assignments = createCOOAssignments(data, userInfo)
                    setSuccessMessage(ERR_ALL_SUP_INVALID);
                }
                setLoading(false);
            });
        }
    }

    return (
        <>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label className="uxf-label">Supplier - Part</Form.Label>
                            <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
                                <InputFile setData={setData} setColDefs={setColumns} loading={loading} />
                            </Stack>
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label className="uxf-label">Supplier Part Template</Form.Label>
                            <Form.Row>
                                <Template csvData={TEMPLATE_COO_COLUMNS} fileName={TEMPLATE_NAME} />
                            </Form.Row>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <DataGrid autoHeight={true} rows={data} columns={columns} disableColumnMenu={true} rowsPerPageOptions={[]} pageSize={10} />
                    </Form.Row>
                </Form.Group>
            </Form.Row>
            <Form.Row className="d-block mb-4">
                <Form.Group as={Col} className="align-right" >
                    <Button variant="secondary" className="float-right" onClick={validateSupplierNumbers} disabled={loading}>
                        Validate Supplier Numbers
                    </Button>
                </Form.Group>
            </Form.Row>
        </>
    )
}
